export default "__VITE_ASSET__DEVcFs2f__"